class ShoppableVideoStories extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-story-track]');
    this.cards = [...this.querySelectorAll('[data-story-card]')];
    this.previousButton = this.querySelector('[data-story-previous]');
    this.nextButton = this.querySelector('[data-story-next]');

    if (!this.track || !this.cards.length) return;

    this.previousButton?.addEventListener('click', () => this.scroll(-1));
    this.nextButton?.addEventListener('click', () => this.scroll(1));
    this.track.addEventListener('scroll', () => this.updateNavigation(), { passive: true });

    this.cards.forEach((card) => {
      const button = card.querySelector('[data-video-toggle]');
      button?.addEventListener('click', () => this.toggleVideo(card));
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.observer = new IntersectionObserver((entries) => this.handleVisibility(entries), {
        root: this.track,
        threshold: 0.65,
      });
      this.cards.forEach((card) => this.observer.observe(card));
    }

    this.updateNavigation();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  scroll(direction) {
    const card = this.cards[0];
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
  }

  updateNavigation() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
    if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
  }

  handleVisibility(entries) {
    entries.forEach((entry) => {
      const video = entry.target.querySelector('video');
      if (!video) return;

      if (entry.isIntersecting) {
        this.cards.forEach((card) => {
          const otherVideo = card.querySelector('video');
          if (otherVideo && otherVideo !== video) otherVideo.pause();
        });
        video.play().catch(() => {});
      } else {
        video.pause();
      }
      this.syncToggle(entry.target);
    });
  }

  toggleVideo(card) {
    const video = card.querySelector('video');
    if (!video) return;
    if (video.paused) video.play().catch(() => {});
    else video.pause();
    this.syncToggle(card);
  }

  syncToggle(card) {
    const video = card.querySelector('video');
    const button = card.querySelector('[data-video-toggle]');
    if (!video || !button) return;
    button.classList.toggle('is-playing', !video.paused);
    button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
  }
}

if (!customElements.get('shoppable-video-stories')) {
  customElements.define('shoppable-video-stories', ShoppableVideoStories);
}
